/**
 * Link
 */
export const GOOGLE_CALENDAR_LINK = `#`;
export const GOOGLE_MAPS_LINK = `https://goo.gl/maps/SKhYGAKv4irDr1Nx5`;
export const GOOGLE_MAPS_EVENT = `https://goo.gl/maps/rRTXyYr7ef3wzy9BA`;

/**
 * Wedding time 1657324939 1657324939 1662861739
 */
export const EPOCH_START_EVENT = 1678068139;
export const EPOCH_END_EVENT = 1678068139;
export const UTC_WEDDING_TIME = '2022-03-05 09:00:00';
